module.exports = __webpack_public_path__ + "images/embed/gear_icon.png";